import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { setDocumentTitleFromPath } from 'utils/pageTitles';

function LoginLayout(props) {
  const location = useLocation();

  useEffect(() => {
    setDocumentTitleFromPath(location.pathname || '/login');
  }, [location.pathname]);

  return <Layout style={{ minHeight: '100vh' }}>{props.children}</Layout>;
}
export default LoginLayout;
